export default {
  control: () => ({
    display: 'flex',
    backgroundColor: 'transparent',
    color: '#8c8c8c',
    fontSize: '16px',
    border: '0',
    borderBottom: '1px solid #e2e2e2',
  }),
  valueContainer: base => ({
    ...base,
    color: '#00BCD4',
    padding: '0',
  }),
  placeholder: base => ({
    ...base,
    color: '#c7c7c7',
  }),
  singleValue: () => ({
    color: '#00BCD4',
    fontSize: '16px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: () => ({
    color: '#8c8c8c',
  }),
  dropdownIndicator: () => ({
    padding: '8px 0',
  }),
  groupHeading: base => ({
    ...base,
    flex: '1 1',
    color: 'white',
    fontSize: '17px',
    background: '#00BCD4',
    margin: 0,
  }),
  option: base => ({
    ...base,
    color: '#8c8c8c',
    fontSize: '16px',
  }),
  placeHolderCss: base => ({
    color: 'red',
  }),
};
